import { get, post } from '@/infrastructure/http-client/axios';

export const apiGetDataUser = async (userCode) =>
  await get(`/attention-queues/v1/catalogueAttention/getDataUser/${userCode}`);

export const apiListScreen = async (payload) =>
  await post(`/attention-queues/v1/catalogueAttention/screenList`, payload);
